import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: CampaignCreateInput!
  ) {
    createOneCampaign(data: $data) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Campanha criada`, mutationTypes.CREATE)
)
